import {style} from '@vanilla-extract/css'

export const menu = style({
  outline: 'none',
  overflow: 'auto',
})
